var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('article',{staticClass:"systempage systempage--bcg2"},[_c('div',{staticClass:"systempage_center"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }